export const VERIFY_LICENCE_SCREEN_TYPES = {
    INTRO: "INTRO",
    UPLOAD_FORM: "UPLOAD_FORM",
    UPLOAD_CONFIRMATION: "UPLOAD_CONFIRMATION"
};
